<template>
    <card title="Completed Patient Cases">
        <CasesListComponent show="completed" show-status read-only />
    </card>
</template>

<script lang="ts">

    import { Component, Vue } from 'vue-property-decorator';
    import CasesListComponent from '@/components/Cases/CasesListComponent.vue'

    @Component({
        name: "ClosedCasesPage",
        components: { CasesListComponent },
    })
    export default class ResolvedCasesPage extends Vue {
        created() {
        }

        beforeDestroy() {
        }
    }
</script>

<style scoped>
</style>
